export const data = [
    {
        id: 1,
        name: "Carson Darrin",
        policyNo: "123456",
        status: "Payment completed",
        date: "Jan 06, 11:49 AM"
    },
    {
        id: 2,
        name: "John",
        policyNo: "5677",
        status: "Policy due for Renewal",
        date: "Jan 20, 1:00 PM"
    },
    {
        id: 3,
        name: "Sophie Clark",
        policyNo: "6542",
        status: "Payment for Policy Completed",
        date: "Feb 19, 2:00 PM"
    },
    {
        id: 4,
        name: "Smith",
        policyNo: "8992",
        status: "",
        date: "Mar 20, 1:00 PM"
    },

]